import { Components, Theme } from "@mui/material";

export const MuiDialogTitle: Components<
  Omit<Theme, "MuiDialogTitle">
>["MuiDialogTitle"] = {
  styleOverrides: {
    root: {
      padding: "24px 24px 8px 24px",
      fontSize: "24px",
      fontWeight: 700,
      marginBottom: 8,
      "& .MuiIconButton-root": {
        color: "#000",
        fontWeight: 700,
      },
    },
  },
};
